export const findElementsByText = (text: string) => {
  const elements = Array.from(document.querySelectorAll('*'));

  return elements.filter((element) => {
    // Skip elements that have no direct text content
    if (!element.textContent) return false;

    // Check if this element has the text directly (not in children)
    const hasDirectText = Array.from(element.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .some((node) => node.textContent?.includes(text));

    // Only return elements that directly contain the text
    // and don't have other elements as children
    return hasDirectText && element.children.length === 0;
  });
};
